import { withTheme } from 'styled-components'

export const IconCheckCircle = withTheme(({ theme, ...props }) => (
	<svg width='1em' height='1em' {...props} viewBox='0 0 82 82' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 41C0 18.3563 18.3563 0 41 0C63.6437 0 82 18.3563 82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41Z'
			fill={theme.color.inputCheckBorder}
		/>
		<path
			d='M36.0574 49.7442L58.0995 26.6654C59.4244 25.2782 61.5726 25.2782 62.8976 26.6654C64.2225 28.0527 64.2225 30.3019 62.8976 31.6892L36.0574 59.7917L20.4683 43.4694C19.1434 42.0821 19.1434 39.8329 20.4683 38.4457C21.7933 37.0584 23.9414 37.0584 25.2664 38.4457L36.0574 49.7442Z'
			fill={theme.color.inputCheckMark}
		/>
	</svg>
))
